import { getDeviceId, getDeviceType, getPublicIp } from './update-session';

type LogLevel = 'INFO' | 'WARNING' | 'ERROR' | 'DEBUG';

interface LogOptions {
    sessionId?: string;
    providerId?: string;
    appId?: string;
    logLevel?: LogLevel;
    eventType?: string;
}

const getClientSource = (): string => {
    const deviceType = getDeviceType();
    return `share-page-${deviceType}`;
};

const fromDateTimeToTimeStamp = (date: Date): string => {
    const ms = date.getTime();
    const ts = (ms * 1000000).toString();
    return ts;
};

export const sendLogs = async (logLine: string, options: LogOptions = {}): Promise<void> => {
    try {
        const deviceId = getDeviceId();
        const deviceType = getDeviceType();
        const publicIpAddress = await getPublicIp();

        const {
            sessionId = '',
            providerId = '',
            appId = '',
            eventType = '',
        } = options;

        const data: Record<string, unknown> = {
            sessionId,
            date: new Date().toISOString(),
            deviceId,
            deviceType,
            providerId,
            applicationId: appId,
            publicIpAddress,
            logType: logLine,
        };

        if (eventType) {
            data.metadata = { eventType };
        }

        const response = await fetch(
            'https://logs.reclaimprotocol.org/api/business-logs/app',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }
        );

        if (!response.ok) {
            console.error('Failed to send logs, response status:', response.status);
        }

        // Also send to log stream
        await sendLogsToLogStream(logLine, deviceId, options);
    } catch (error) {
        console.error('Error sending logs to backend server:', error);
    }
}

export const sendLogsToLogStream = async (logLine: string, deviceId: string, options: LogOptions = {}): Promise<void> => {
    try {
        const {
            sessionId = '',
            providerId = '',
            appId = '',
            logLevel = 'INFO',
            eventType = '',
        } = options;

        const logEntry = {
            logLine,
            ts: fromDateTimeToTimeStamp(new Date()),
            type: getClientSource(),
            sessionId,
            providerId,
            appId,
            logLevel,
            eventType,
        };

        const body = {
            logs: [logEntry],
            source: getClientSource(),
            deviceId,
        };

        const response = await fetch(
            'https://logs.reclaimprotocol.org/api/business-logs/logDump',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            }
        );
        console.log('Response from logs backend:', response);

        if (!response.ok) {
            console.error('Failed to send logs, response status:', response.status);
        }
    } catch (error) {
        console.error('Error sending logs to backend server:', error);
    }
};
